
import React, { useState, useEffect, useContext } from "react"

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { SubMenu } from "./SubMenu";
import SelectLanguage from "../SelectLanguage/SelectLanguage";

import styles from './NavBar.module.css'
import menuDataKor from './navBarDataKor.json'
import menuDataEng from './navBarDataEng.json'
import { Link, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/languageContext";

const NavBar = () =>{
  const { isLanguage, setIsLanguage } = useContext(LanguageContext);
  const [ menu, setMenu ] = useState(menuDataKor);
  const [ anchorElNav, setAnchorElNav ] = useState(null);
	const [ expanded, setExpanded ] = useState(false);
  const [ screenSize, setScreenSize ] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [ hoverStates, setHoverStates ] = useState({ COMPANY: false, BUSINESS: false, PRIR: false, CONTACTS: false, GEDSITE: false });
  const [ activatedHoverData, setActivatedHoverData] = useState({});
  const [ showSubMenu, setShowSubMenu ] = useState(false)
  const navigate = useNavigate();

  useEffect(()=>{
    setMenu(isLanguage === 20 ? menuDataKor: menuDataEng);
  },[isLanguage])

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setExpanded(true);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const hoverEnterHandler = (index, stateName) => {
    setHoverStates({ COMPANY: false, BUSINESS: false, PRIR: false, CONTACTS: false, GEDSITE: false });
    setHoverStates((prev) => { return {...prev, [stateName]: true } });
    setActivatedHoverData(menu[index])
    setShowSubMenu(true);
  };

  const hoverLeaveHandler = (index) => {
    setHoverStates({ COMPANY: false, BUSINESS: false, PRIR: false, CONTACTS: false, GEDSITE: false });
    setShowSubMenu(false);
  };

  const handleSubMenuEnter = (stateName) => {
    // 서브메뉴에 마우스가 들어왔을 때, 타이머 초기화하여 서브메뉴 유지
    setHoverStates({ COMPANY: false, BUSINESS: false, PRIR: false, CONTACTS: false, GEDSITE: false });
    setHoverStates((prev) => { return {...prev, [stateName]: true } });
    setShowSubMenu(true)
  };

  const handleSubMenuLeave = () => {
    // 서브메뉴에서 마우스가 벗어났을 때, 타이머 시작하여 submenu가 사라지도록 함
    setHoverStates({ COMPANY: false, BUSINESS: false, PRIR: false, CONTACTS: false, GEDSITE: false });
    setShowSubMenu(false);
  };

  const movePageHandler = (URL) => {
    navigate(URL);
  };

  const handleMenuClick = (data) => {
    if (data.externalLink) {
      window.open(data.route, '_blank', 'noopener,noreferrer');
      return;
    }
    movePageHandler(process.env.PUBLIC_URL + data.route);
  };

  const renderMenuLabel = (data) => {
    if (data.menuLines) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            lineHeight: 1.2,
            fontWeight: 700,
          }}
        >
          {data.menuLines.map((line, i) => {
            const isLastLine = i === data.menuLines.length - 1;
            if (isLastLine && data.externalLink) {
              return (
                <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <span>{line}</span>
                  <OpenInNewIcon sx={{ fontSize: '16px' }} />
                </Box>
              );
            }
            return <span key={i}>{line}</span>;
          })}
        </Box>
      );
    }
    return data.menu;
  };
  
  return (
    <>
      <div className={styles.navBarWrapper} >
        <AppBar position="static"  sx={{transform: `scaleX(${expanded ? '1' : '0'})`, transition: 'transform ,1.5s', margin: 'auto', borderRadius:"0 0 10px 10px", backgroundColor:"transparent",border: "0px", boxShadow: "none" }}>
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              {screenSize.width > 899 ? 
                (<Link to={process.env.PUBLIC_URL + "/"} style={{textDecoration: "none", cursor:"pointer"}}>
                  <img src={ process.env.PUBLIC_URL + "/img/logo.png"} style={{width:"25.5px", height:"26px"}} alt="logo"/>
                </Link>)
                :
                null }
              {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex', fontSize: "30px" }, mr: 1 }} /> */}
              <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                  mr: 2,
                  display: { xs: 'none', md: 'flex' },
                  fontFamily: 'monospace',
                  fontWeight: 700,
                  letterSpacing: '.3rem',
                  color: 'inherit',
                  textDecoration: 'none',
                  fontSize: "30px",
                  marginLeft:"10px"
                }}
              > 
                <Link to={process.env.PUBLIC_URL + "/"} style={{textDecoration: "none", cursor:"pointer", marginBottom: "0px", paddingBottom: "-5px"}}>
                  <span style={{color:"#ca4b34", fontSize: "35px"}}>G</span>
                  <span style={{color:"#4975DB", fontSize: "35px"}}>E</span>
                  <span style={{color:"#4975DB", fontSize: "35px"}}>D</span>
                </Link>
              </Typography>

              <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: 'block', md: 'none' },
                  }}
                >
                  {menu.map((data, index) => {
                    return (
                      <MenuItem 
                        key={data.id} 
                        onClick={()=>{
                          handleCloseNavMenu();
                          handleMenuClick(data);
                        }}

                      >
                        <Typography textAlign="center">
                          {renderMenuLabel(data)}
                        </Typography>
                      </MenuItem>
                  )})}
                </Menu>
              </Box>
              {screenSize.width < 899 ? 
                (<Link to={process.env.PUBLIC_URL + "/"} style={{textDecoration: "none", cursor:"pointer"}}>
                <img src={process.env.PUBLIC_URL + "/img/logo.png"} style={{width:"25.5px", height:"26px"}} alt="logo"/>
                </Link>)
                : 
                null }
              {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
              <Typography
                variant="h5"
                noWrap
                component="a"
                href="/"
                sx={{
                  mr: 2,
                  display: { xs: 'flex', md: 'none' },
                  flexGrow: 1,
                  fontFamily: 'monospace',
                  fontWeight: 700,
                  letterSpacing: '.3rem',
                  color: 'inherit',
                  textDecoration: 'none',
                  fontSize: "30px",
                  marginLeft:"10px"
                }}
              >
                <Link to={ process.env.PUBLIC_URL + "/"} style={{textDecoration: "none", cursor:"pointer", marginBottom: "0px", paddingBottom: "-5px"}}>
                  <span style={{color:"#ca4b34", fontSize: "35px"}}>G</span>
                  <span style={{color:"#4975DB", fontSize: "35px"}}>E</span>
                  <span style={{color:"#4975DB", fontSize: "35px"}}>D</span>
                </Link>
              </Typography>
              {/*  확장 메뉴 */}
              <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }}}>
                {menu.map((data, index) => {
                  return(
                    <Button
                      size="large"
                      key={index + data.id}
                      onClick={() => handleMenuClick(data)}
                      onMouseEnter={() => hoverEnterHandler(index, data.stateName)}
                      onMouseLeave={() => hoverLeaveHandler(index, data.stateName)}
                      sx={{ mr: 2, my: 2, color: `${hoverStates[`${data.stateName}`]? "#494949":"#b0b8ca"}`,
                          display: 'flex', alignItems: 'center', gap: 0.5, fontWeight:"700", height:"100%", marginRight:"15px", marginBottom: "0px", paddingBottom: "16px",
                          ...(data.menuLines && { minWidth: 'auto', px: 1 }) }}
                    >
                        {renderMenuLabel(data)}
                    </Button>
                    )}
                )}
              </Box>
              <SelectLanguage/>
            </Toolbar>
          </Container>
        </AppBar>
        {showSubMenu === true && activatedHoverData.menu !== "CONTACT" && !activatedHoverData.externalLink ? 
          (<SubMenu
            activatedHoverData={activatedHoverData}
            handleSubMenuEnter={handleSubMenuEnter}
            handleSubMenuLeave={handleSubMenuLeave}
          />) 
          : 
          null}
      </div>	
    </>
  )
}

export default NavBar


